export const soldierLevelPageLayoutByVariant = {
  desktop: {
    pl: 156,
    pr: 156,
    px: 156,
    title: {
      py: 160,
    },
  },
  laptop: {
    pl: 24,
    pr: 24,
    px: 24,
    title: {
      py: 80,
    },
  },
  mobile: {
    pl: 16,
    pr: 16,
    px: '8px',
    title: {
      py: 40,
    },
  },
  tablet: {
    pl: 24,
    pr: 24,
    px: 24,
    title: {
      py: 40,
    },
  },
};

const certificationTranslations = {
  en: {
    description:
      'The certification segment serves as a comprehensive examination, testing the depth of understanding and knowledge amassed from the preceding modules. It covers the key principles of IHL, including the treatment of civilians, the rules of engagement, handling prisoners of war, and the importance of distinguishing between combatants and non-combatants, all within the context of modern military operations.',
    title: 'Certification',
  },
  ua: {
    description:
      'Сертифікація є всебічним іспитом, перевіряючим глибину розуміння та знання, накопичені з попередніх модулів. Він охоплює ключові принципи МГП, зокрема поводження з цивільними особами, правила ведення бойових дій, поводження з військовополоненими та важливість розрізнення між комбатантами та некомбатантами в контексті сучасних військових операцій.',
    title: 'Сертифікація',
  },
};
export const getCertificationModule = ({ course, language }) => ({
  certification: true,
  description: certificationTranslations[language || 'en'].description,
  id: 101,
  image: `https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/certification-${course?.id}.png`,
  is_available: course?.is_available,
  is_passed: course?.is_passed,
  lessons_count: 0,
  minutes_count: 60,
  passed: 0,
  title: certificationTranslations[language || 'en'].title,
});
